import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import './css/homepage.css';
import Welcome from '../Components/Homepage/Welcome';
import MasterLanding from '../Components/Master/MasterLanding';
import EmployeeLanding from '../Components/Employee/EmployeeLanding';

class EmployeeContainer extends Component {
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                    <EmployeeLanding />

                </div>
            </div>
        )
    }
}

export default withAuth(EmployeeContainer);


// WEBPACK FOOTER //
// ./src/Containers/EmployeeContainer.js